import { z } from "zod";

export const schema = z.object({
	id_credenciais: z.number().int(),
	id_credenciais_tipo: z.coerce.number().int().min(1, "Selecione um tipo"),
	descricao: z.string().min(1, "Descrição é obrigatória"),
	url: z.string().min(1, "URL é obrigatória"),
	api_key: z.string().optional(),
	obs: z.string().nullable().optional(),
	ativo: z.boolean(),
}).refine((data) => {
	if (data.id_credenciais === 0 && (!data.api_key || data.api_key.length === 0)) {
		return false;
	}
	return true;
}, {
	message: "API Key é obrigatória para novas credenciais",
	path: ["api_key"]
});
